module.exports = __webpack_public_path__ + "img/social_media_baidu.7a3b0dac.png";